import { get, keyBy } from 'lodash/fp';

import ProductService from '../../models/product';
import UrlService from '../../models/url';

// @ts-expect-error - Automatic, Please fix when editing this file
const getCombinedProductUrl = ({ cartProduct, chosenProduct }) => {
  const productsArray = keyBy((product: { type: string }) => product.type, [cartProduct, chosenProduct]);
  const combinedCartProduct = ProductService.getCombinedCartObject({ ...productsArray } as any);
  const combinedProductId = get('id', combinedCartProduct);
  return UrlService.getProductUrl(combinedProductId);
};

export default getCombinedProductUrl;
